<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.appPageDeletedList.push"
    :is-show-search-input="true"
    search-placeholder="输入页面名称进行搜索"
  >
    <v-column-time value="删除时间" field="del_time"/>
    <v-column-time sortable=""/>
    <v-column-time value="修改时间" field="update_time" sortable=""/>
    <el-table-column label="ID" prop="id"/>
    <el-table-column label="页面名称" prop="page_name"/>

    <el-table-column width="210" label="操作">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.appPageEdit.to(row.id)"/>

        <v-list-button
          name="恢复"
          icon="restore"
          @click="handleRestore(row.id)"
          :is-loading="isRestoring[row.id]"
          message="确定要恢复此小程序页面吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`app-page-deleted-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.del_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>页面名称</span>
              <span>{{ v.page_name }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.appPageEdit.to(v.id)"/>
              <v-list-button
                name="恢复"
                icon="restore"
                @click="handleRestore(v.id)"
                :is-loading="isRestoring[v.id]"
                message="确定要恢复此小程序页面吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, restore } from '@/api/app-page';

export default {
  name: RouteConfig.appPageDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isRestoring: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 8,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      const { ...params } = queryList;
      params.is_del = 1;

      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleRestore(id) {
      if (!id) return this.$message.warning('缺少小程序页面 ID，无法恢复该页面！');
      if (this.isRestoring[id]) return;

      this.$set(this.isRestoring, id, true);
      const { isError } = await restore(id);
      this.$set(this.isRestoring, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
